import Header from './Header.vue'

export default Header
